import React from 'react';
import { Button } from './Button';
import { CheckIcon } from 'lucide-react';
export const Benefits = () => {
  const benefits = [{
    title: 'Estrategias Reales',
    description: 'Métodos probados que funcionan con salarios latinoamericanos y nuestra realidad económica'
  }, {
    title: 'Sin Teoría Abstracta',
    description: 'Pasos concretos y accionables que puedes implementar desde el primer día'
  }, {
    title: 'Para Tu Contexto',
    description: 'Diseñado específicamente para la inflación, devaluación y desafíos de LATAM'
  }, {
    title: 'Resultados Medibles',
    description: 'Sistema de seguimiento para ver tu progreso financiero mes a mes'
  }];
  const checkoutUrl = 'https://jancinas.com/checkouts/cn/hWN5NlkHONW0RzioeC4WJl5d/es-cl?_r=AQAB_muHi4WYbjqTrBznEaayCCMWWHCjPuTB_g6JEDp4-0I&preview_theme_id=186408665457';
  return <section id="beneficios" className="py-16 bg-white" data-id="element-17">
      <div className="container mx-auto px-4" data-id="element-18">
        <div className="text-center mb-12" data-id="element-19">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-4" data-id="element-20">
            ¿Qué Hace Diferente Este Método?
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-21">
            No más consejos genéricos que no funcionan en tu realidad
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto mb-12" data-id="element-22">
          {benefits.map((benefit, index) => <div key={index} className="bg-gradient-to-br from-orange-50 to-white p-8 rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300 border-l-4 border-orange-500" data-id="element-23">
              <div className="flex items-start gap-4" data-id="element-24">
                <div className="bg-orange-500 p-2 rounded-full flex-shrink-0" data-id="element-25">
                  <CheckIcon size={20} className="text-white" data-id="element-26" />
                </div>
                <div data-id="element-27">
                  <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-28">
                    {benefit.title}
                  </h3>
                  <p className="text-gray-600" data-id="element-29">{benefit.description}</p>
                </div>
              </div>
            </div>)}
        </div>
        <div className="text-center mt-12" data-id="element-30">
          <Button href={checkoutUrl} data-id="element-31">Comienza Tu Transformación Ahora</Button>
        </div>
      </div>
    </section>;
};